export const siteInfo = {
  name: '爱液视频',
  tagline: '精选高清视频资源聚合平台',
  description: '爱液视频致力于为广大用户提供海量精选高清视频内容，汇聚多元化视频资源，涵盖动作、喜剧、剧情、科幻、纪录、动漫等多种类型。我们坚持内容为王，每日更新，让每一位用户都能在这里找到心仪的精彩视频。',
  founded: '2020',
  totalVideos: '50,000+',
  dailyUsers: '200万+',
  monthlyViews: '1.2亿+',
  rating: '4.9',
  email: 'contact@aiyeshipin.com',
  phone: '400-888-9999',
  address: '北京市朝阳区望京科技园A座18层',
  socialLinks: {
    weibo: 'https://weibo.com/aiyeshipin',
    wechat: 'aiyeshipin',
    bilibili: 'https://space.bilibili.com/aiyeshipin',
  },
};

export const stats = [
  { label: '高清视频资源', value: '50,000+', icon: 'ri-film-line' },
  { label: '日均活跃用户', value: '200万+', icon: 'ri-user-line' },
  { label: '月播放量', value: '1.2亿+', icon: 'ri-play-circle-line' },
  { label: '用户好评率', value: '99.8%', icon: 'ri-thumb-up-line' },
];

export const milestones = [
  { year: '2020', title: '平台创立', description: '爱液视频平台正式上线，专注高清视频资源聚合服务。' },
  { year: '2021', title: '用户突破百万', description: '凭借优质内容和流畅体验，注册用户突破100万。' },
  { year: '2022', title: '内容生态完善', description: '覆盖六大视频分类，建立完善的内容审核和推荐体系。' },
  { year: '2023', title: '技术全面升级', description: '引入AI智能推荐，4K超高清播放，CDN全国加速。' },
  { year: '2024', title: '行业领先', description: '成为中国领先的视频资源聚合平台，月活跃用户超千万。' },
  { year: '2025', title: '生态扩展', description: '拓展原创内容和社区互动功能，构建完整视频生态。' },
  { year: '2026', title: '全球化布局', description: '启动多语言版本，向全球用户提供精选视频内容服务。' },
];